// Constants associated with items stored in local storage

export const LS_NEXT_PATH_KEY = 'next_path'
export const LS_ID_TOKEN_KEY = 'id_token'
export const LS_ACCESS_TOKEN_KEY = 'access_token'
export const LS_PROFILE_KEY = 'profile'
export const LS_HOMEPAGE_KEY = 'homepage'
export const LS_OPENAI_TOKEN_ID = 'tokenid'
